const COMPONENT = '[data-toggle="lightbox"]';

export default function(isBackEnd) {
  if (isBackEnd)
  {
    return;
  }

  if ($(COMPONENT).length)
  {
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
      event.preventDefault();
      $(this).ekkoLightbox();
    });
  }
}
